var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYouTubeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7208 5.13101C28.0116 5.47824 29.0281 6.5013 29.3731 7.8005C30 10.1552 30 15.0681 30 15.0681C30 15.0681 30 19.981 29.3731 22.336C29.0281 23.635 28.0116 24.6582 26.7208 25.0055C24.3813 25.6364 15 25.6364 15 25.6364C15 25.6364 5.6187 25.6364 3.2792 25.0055C1.98852 24.6582 0.971931 23.635 0.626931 22.336C0 19.981 0 15.0681 0 15.0681C0 15.0681 0 10.1552 0.626931 7.8005C0.971931 6.5013 1.98852 5.47824 3.2792 5.13101C5.6187 4.5 15 4.5 15 4.5C15 4.5 24.3813 4.5 26.7208 5.13101ZM19.7728 15.0683L11.9319 19.5288V10.6075L19.7728 15.0683Z",
    fill: "#D4D4D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTubeLogo);
export default __webpack_public_path__ + "static/media/YouTubeLogo.10f56c77b09c8a15e8c7995c65bb5ec0.svg";
export { ForwardRef as ReactComponent };